import { ScreenSize } from './../../../styles/screen-sizes';
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import produce from 'immer';
import Presentation from '.';
import { ToastPayload } from './presentation-models';

const initializeState: Presentation.model.PresentationReducer = {
  toast: undefined,
  modalContent: undefined,
  screenSize: undefined,
  onClose: undefined,
};

export default (
  state = initializeState,
  action: { type: string; payload: Presentation.model.PresentationActionsPayload },
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Presentation.actionTypes.SET_TOAST:
        draft.toast = action.payload as ToastPayload | undefined;
        return draft;
      case Presentation.actionTypes.SET_SHOW_MODAL:
        // eslint-disable-next-line no-case-declarations
        const payload = action.payload as {
          content?: JSX.Element | undefined;
          onClose?: () => void;
        };
        draft.modalContent = payload.content;
        console.log('SET_SHOW_MODAL', payload.onClose);
        draft.onClose = payload.onClose;
        return draft;
      case Presentation.actionTypes.SET_SCREEN_SIZE:
        draft.screenSize = action.payload as ScreenSize;
        return draft;
      default:
    }
  });
